import IntervalTree from 'node-interval-tree';
import start_data from '../asset/start.json';
import suggestions from '../asset/suggestion.json'; // Directly import JSON

// State is managed by the module itself.
// These are initialized only once when the module is first imported.
const per_vol_tree: { [key: string]: IntervalTree<string> } = {};
let is_initiated = false;

function book2pdf(book_page: number, vol_name: string): number {
  // ... (same as your original function)
  let ret_page = book_page + start_data[vol_name];
  switch (vol_name) {
    case 'Volume_10':
      if (book_page > 398) return ret_page + 4;
      break;
    case 'Volume_15':
      if (book_page > 704) return ret_page + 2;
      break;
    case 'Volume_17_02':
      if (book_page > 300) return ret_page + 2;
      break;
    default:
      return ret_page;
  }
  return ret_page;
}

// No need for async if the JSON can be imported directly
export function initiate_interval_tree() {
  if (is_initiated) {
    return; // Already done
  }

  for (const suggestion of suggestions) {
    if (!per_vol_tree[suggestion.vol_name]) {
      per_vol_tree[suggestion.vol_name] = new IntervalTree<string>();
    }

    const tree = per_vol_tree[suggestion.vol_name];
    const page_start = book2pdf(suggestion.page_start, suggestion.vol_name);
    const page_end = book2pdf(suggestion.page_end, suggestion.vol_name);

    // Create a new object for insertion to avoid modifying the original suggestion data
    const to_insert = { ...suggestion, page_start, page_end };

    tree.insert(page_start, page_end, JSON.stringify(to_insert));
  }

  is_initiated = true;
}

export function getUrlContext(url: string) {
  // ... (same as your original function)
  const splitURL = url.split('/');
  if (splitURL[2] !== 'baws' || splitURL[3] !== 'EN') return null;

  const container = splitURL[4];
  const page = parseInt(splitURL[6]);

  if (per_vol_tree[container]) {
    return per_vol_tree[container].search(page, page);
  }
  return null;
}

export function getPageContext(item: {
  actual_page: { raw: string };
  container: { raw: string };
}) {
  // ... (same as your original function)
  const to_find = parseInt(item.actual_page.raw);
  const container = item.container.raw;
  if (per_vol_tree[container]) {
    return per_vol_tree[container].search(to_find, to_find);
  }
  return null;
}
